import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=6de8aa16&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6de8aa16')) {
      api.createRecord('6de8aa16', component.options)
    } else {
      api.reload('6de8aa16', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=6de8aa16&", function () {
      api.rerender('6de8aa16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2N2sebWrya0Xw/JS/offershelp.vue"
export default component.exports